import script from "./AdventureChatMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdventureChatMessage.vue?vue&type=script&setup=true&lang=js"

import "./AdventureChatMessage.vue?vue&type=style&index=0&id=7cd3cdd7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cd3cdd7"]])

export default __exports__